/* ============================================================
   HARD.NOISE — Merch JS (isoliert, gehört zu hn-merch.css)
   PDP-Beschreibung → saubere Hierarchie:
   - Zeilen OHNE ":"  = Einleitung/Features (oben, gut lesbar)
   - Zeilen MIT  ":"  = Tech-Specs (darunter, 2-spaltig Label/Wert)
   Idempotent + Editor-sicher. Verändert KEINE Vessel-Kerndatei.
   ============================================================ */
(function () {
  function buildSpecs(root) {
    var scope = root || document;
    var lists = scope.querySelectorAll('.product-information .text-block ul');
    lists.forEach(function (ul) {
      if (ul.dataset.hnSpec === '1') return;
      var lis = Array.prototype.slice.call(ul.querySelectorAll(':scope > li'));
      if (!lis.length) return;
      ul.dataset.hnSpec = '1';
      ul.classList.add('hn-spec');

      var feats = [];
      var specs = [];
      lis.forEach(function (li) {
        var txt = (li.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt) return;
        var idx = txt.indexOf(':');
        if (idx > 0 && idx < txt.length - 1) {
          specs.push({ li: li, k: txt.slice(0, idx).trim(), v: txt.slice(idx + 1).trim() });
        } else {
          feats.push({ li: li, t: txt });
        }
      });

      // Reihenfolge: erst Features (Einleitung), dann Specs (Datenblatt)
      feats.forEach(function (o) {
        o.li.className = 'hn-feat';
        o.li.textContent = '';
        var s = document.createElement('span');
        s.className = 'hn-feat__t';
        s.textContent = o.t;
        o.li.appendChild(s);
        ul.appendChild(o.li);
      });
      specs.forEach(function (o, i) {
        o.li.className = 'hn-spec-row' + (i === 0 ? ' hn-spec-row--first' : '');
        o.li.textContent = '';
        var k = document.createElement('span');
        k.className = 'hn-spec__k';
        k.textContent = o.k;
        var v = document.createElement('span');
        v.className = 'hn-spec__v';
        v.textContent = o.v;
        o.li.appendChild(k);
        o.li.appendChild(v);
        ul.appendChild(o.li);
      });
    });
  }

  function init() { buildSpecs(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { buildSpecs(e.target || document); });
})();
